export const Admin404NotFound = () => {
	return (<div></div>);
}